module.exports = __webpack_public_path__ + "media/images/linkedin-1959ec21.png";